<template>
  <section-hoc mode="full" :variant="7" class="wrapper" size="cover">
    <div class="wrapper">
      <div class="flex-row">
        <logo mode="horizontal-white" class="logo" width="400"></logo>
      </div>
      <div class="flex-row">
        <h1 class="title" style="color: var(--lt1);">
          <slot></slot>
        </h1>
      </div>
      <div class="flex-row speaker">
        <h6 class="speaker__name" style="color: var(--lt1);">Vladimir Ulianov</h6>
      </div>
    </div>
  </section-hoc>
</template>

<script>
import SectionHoc from "./SectionHoc";
import Logo from "./Logo";

export default {
  components: { "section-hoc": SectionHoc, logo: Logo }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: left;
}

.speaker {
  margin-top: auto;
  margin-bottom: 2em;
}

.title {
}
</style>